/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogSearchRequest = {
    filterBy?: ZerogSearchRequest.filterBy;
    term: string;
};

export namespace ZerogSearchRequest {

    export enum filterBy {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        VALIDATOR = 'VALIDATOR',
        TOKEN = 'TOKEN',
        STORAGE_SUBMISSION = 'STORAGE_SUBMISSION',
        ALL = 'ALL',
    }


}

